import SocialShare from 'js/modules/module-social-share';
import Affix from 'js/modules/module-affix';
import readingTime from 'reading-time';

// CSS
import 'sass/pages/page-single/page-single.scss';

jQuery(function ($) {
  // ON DOCUMENT READY
  $(document).ready(() => {
    if ($('.js-rooster-affix').length) {
      new Affix($('.js-rooster-affix'));
    }

    if ($('.js-rooster-share').length) {
      $('.js-rooster-share').each((key, ele) => {
        new SocialShare($(ele));
      });
    }

    if ($('.reading-time').length) {
      const readingTimeData = readingTime($('[data-readingtime]').text(), {
        wordsPerMinute: 250,
      });

      const minutes = Math.round(readingTimeData.minutes);
      const string =
        minutes <= 1 ? roostermoney.reading_time_singular : `${minutes} ${roostermoney.reading_time_plural}`;

      $('.reading-time').text(string);
    }
  });
});
